import { HttpErrorResponse } from '@angular/common/http';
import {
  getInitialLoadingState,
  LoadingState,
} from '@ip-only/front-end-library';
import { LeafletMouseEvent } from 'leaflet';
import { BehaviorSubject, Subject } from 'rxjs';

export abstract class AbstractLayerService<T> {
  protected layerData: T;

  private clicked$ = new Subject<{
    e: LeafletMouseEvent;
    args?: { [key: string]: any };
  }>();
  protected loadingState$ = new BehaviorSubject<LoadingState>(
    getInitialLoadingState(),
  );

  constructor(private initialData: T) {
    this.clearData();
  }

  abstract loadData(ifs: string): void;

  getLoadingState$() {
    return this.loadingState$.asObservable();
  }

  getLayerData() {
    return this.layerData;
  }

  getClicked$() {
    return this.clicked$.asObservable();
  }

  clearData() {
    if (this.initialData == null) {
      this.layerData = this.initialData;
    } else {
      this.layerData = { ...this.initialData };
    }
  }

  protected onClick(e: LeafletMouseEvent, args?: { [key: string]: any }) {
    this.clicked$.next({ e, args });
  }

  protected setLoading() {
    this.loadingState$.next({
      ...getInitialLoadingState(),
      isLoading: true,
    });
  }

  protected setLoaded() {
    this.loadingState$.next({
      ...this.loadingState$.getValue(),
      isLoading: false,
      hasLoaded: true,
    });
  }

  protected handleError(err: HttpErrorResponse) {
    console.error(err);
    this.loadingState$.next({
      isLoading: false,
      hasLoaded: false,
      hasError: true,
      error: {
        code: err.status,
        message: '',
      },
    });
  }
}
